import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiOptionItem, APIResponse } from '../interfaces/api.interface';
import { SampleSuite } from '../interfaces/option.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class OptionService {
  public constructor(private readonly api: ApiService) {}

  public getSampleSuites(
    organisationId: string,
  ): Observable<APIResponse<SampleSuite[]>> {
    return this.api.get<APIResponse<SampleSuite[]>>(
      `organisations/${organisationId}/options/suites`,
    );
  }

  public getSampleTypes(
    organisationId: string,
  ): Observable<APIResponse<string[]>> {
    return this.api.get<APIResponse<string[]>>(
      `organisations/${organisationId}/options/types`,
    );
  }

  public getSampleMatrices(
    organisationId: string,
  ): Observable<APIResponse<ApiOptionItem[]>> {
    return this.api.get<APIResponse<ApiOptionItem[]>>(
      `organisations/${organisationId}/options/matrices`,
    );
  }
}
